import { Link } from "react-router";

import { Pill, Surface } from "@/components/glass";

export default function NotFound() {
	return (
		<Surface className="min-h-screen flex items-center justify-center p-4">
			<div className="text-center space-y-4">
				<div className="text-5xl mono text-[var(--color-text-dim)]">404</div>
				<div className="text-[13px] text-[var(--color-text-muted)]">
					This page doesn't exist.
				</div>
				<div className="flex justify-center pt-2">
					<Link to="/">
						<Pill>Go home</Pill>
					</Link>
				</div>
			</div>
		</Surface>
	);
}
